////////////////////////////////////////////////////////////////////////////////
// History
////////////////////////////////////////////////////////////////////////////////


class History extends Pages {

	constructor(entry) {
		super(entry)
	}

	// ===========================================================================
	// Initialisation
	// ===========================================================================

	in(content, done) {

		$('site-wrapper > *:last-child').before(content)

		done()

		let articles = $('site-wrapper').find('timeline-blocks article')
		let buttons = articles.find('button')


		if ( browser.name == 'safari') {
			console.log('Updating Timeline Height for Safari')
			$('timeline-blocks').height($('timeline-years').height())
		} else {
			console.log('Timeline height is correct')
		}

		// $('timeline-blocks').css('height', $('timeline-blocks').height())

		buttons.on('click', (event) => {

			event.preventDefault()

			let $this = $(event.currentTarget)
			let active = articles.find('> div.active')

			if ( !$this.parent().hasClass('active')) {

				// Get the height of the text block
				let newHeight = $this.nextAll('div').find('p').innerHeight();

				// Add the active state to the current block
				$this.nextAll('div').height(newHeight).transitionend('height', () => {
				  $this.nextAll('div').css({'height':'auto'})
				}).parent().addClass("active")
			}

			// Remove the active states from the current block
			if (active.length) {
				active.find('div').height(active.find('p').innerHeight()).height(0).transitionend('height', () => {
					active.find('div').height(0)
				}).parent().removeClass("active")
			}

		})

		$('[animatable]').when('inview', {
			in  : (element) => { element.setAttribute('animate', '') },
			out : (element) => { element.removeAttribute('animate') }
		})

		when.trigger()


	}

}
